import { gql } from "@apollo/client";

export const organizationDetailsFragment = gql`
    fragment OrganizationDetails on CameraKitOrganization {
        id
        name
        role
    }
`;
